<template>
	<div>
		<spinner v-if="invitations.loading"/>
		<div v-if="invitations.data.length" class="idi-table invitations">
			<div class="idi-header">
				<div class="idi-cell">{{ $t('labels.general.name') }}</div>
				<div class="idi-cell">{{ $t('labels.general.email') }}</div>
				<div class="idi-cell">{{ $t('labels.general.created') }}</div>
				<div class="idi-cell">{{ $t('labels.general.status') }}</div>
				<div class="idi-cell"></div>
			</div>
			<div class="idi-row" v-for="invitation in invitations.data" :key="invitation.id">
				<div class="idi-cell grid-area-name">{{ invitation.name }}</div>
				<div class="idi-cell grid-area-email">{{ invitation.email }}</div>
				<div class="idi-cell grid-area-created">{{ invitation.create_time | timeAgo(vue) }}</div>
				<div class="idi-cell grid-area-status">{{ invitation.status }}</div>
				<div class="idi-cell grid-area-operations">
					<button @click="resendInvitation(invitation.id)" class="btn btn-small btn-round">{{ $t('labels.general.resend') }}</button>
				</div>
			</div>
		</div>
		<p v-if="!invitations.loading && !invitations.data.length" class="no-results">{{ $t('labels.general.no_results') }}</p>
		<router-view/>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			vue: this,
			invitations: {
				loading: false,
				error: null,
				data: []
			}
		}
	},
	methods: {
		getInvitations () {
			const getAllAccept = () => {
				return this.$api.invitations.getAllAccept(this, this.user_uid)
					.then(response => response.body)
			}
			const getAllPendent = () => {
				return this.$api.invitations.getAllPendent(this, this.user_uid)
					.then(response => response.body)
			}
			this.invitations.loading = true
			this.invitations.data = []
			Promise.all([ getAllAccept(), getAllPendent() ])
				.then(([ acceptResult, pendentResult ]) => {
					this.$log.info('staff invitations', 'getInvitations() OK', [ acceptResult, pendentResult ])()
					acceptResult.forEach(element => {
						element.status = 'Accepted'
						this.invitations.data.push(element)
					})
					pendentResult.forEach(element => {
						element.status = 'Sent'
						this.invitations.data.push(element)
					})
				})
				.catch(error => {
					this.$log.error('staff invitations', 'getInvitations() ERROR', error)()
					this.invitations.error = error
				})
				.finally(() => {
					this.invitations.loading = false
				})
		},
		resendInvitation (id) {
			this.$api.invitations.resend(this, this.user_uid, id).then(response => {
				this.$log.info('staff invitations', 'invitations.resend OK', response)()
				this.$root.$emit('add-floating-box', { title: 'Success', text: 'Invitation resent.' })
			}).catch(error => {
				this.$log.error('staff invitations', 'invitations.resend ERROR', error)()
			})
		},
	},
	mounted () {
		this.getInvitations()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/staff/StaffInvitations.vue